import Component from '../inherited/Component'

export default class TidioChatButton extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }
 
  async mount () {
    let onTidioChatApiReady = () => {
      this._elem.addEventListener('click', () => {
          window.tidioChatApi.open();
      })

      let iframe = document.querySelector('#tidio-chat-iframe')
      if (iframe) {
        this._elem.classList.remove('hide')
      }
    }

    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
      document.addEventListener("tidioChat-ready", onTidioChatApiReady);
    }
  }
}